const mapObj = require('map-obj')
const isPlainObj = require('is-plain-obj')
const flow = require('lodash.flow')
const merge = require('lodash.merge')

const normalizeSvensktBankgironummer = require('./lib/svenskt-bankgironummer')
const normalizeSvensktPlusgironummer = require('./lib/svenskt-plusgironummer')
const normalizeSvensktPersonnummer = require('./lib/svenskt-personnummer')
const normalizeSvensktBankClearingnummer = require('./lib/svenskt-bank-clearingnummer')
const normalizeSvensktBankKontonummer = require('./lib/svenskt-bank-kontonummer')
const normalizeSvensktOrganisationsnummer = require('./lib/svenskt-organisationsnummer')
const normalizeSvensktPostnummer = require('./lib/svenskt-postnummer')
const normalizePhoneNumber = require('./lib/phone-number')
const normalizeDate = require('./lib/date')
const normalizeHttpUri = require('./lib/http-uri')
const normalizeEmail = require('./lib/email')
const normalizeTime = require('./lib/time')

function normalizeArray(schema, input, customNormalizers) {
  if (!Array.isArray(input)) return input
  if (!isPlainObj(schema.items)) return input

  return input.map(value => {
    return normalizeSchema(schema.items, value, customNormalizers)
  })
}

function normalizeObject({ oneOf = [], anyOf = [], ...schema }, input, customNormalizers) {
  if (!isPlainObj(input)) return input

  if (oneOf.length > 0 || anyOf.length > 0) {
    return flow(
      [...oneOf, ...anyOf].map(subSchema => oneOfInput =>
        normalizeObject(merge({}, schema, subSchema), oneOfInput, customNormalizers)
      )
    )(input)
  }

  return mapObj(input, (key, value) => {
    if (!schema.properties) return [key, value]

    if (isPlainObj(schema.properties[key])) {
      return [key, normalizeSchema(schema.properties[key], value, customNormalizers)]
    }
    return [key, value]
  })
}

function normalizeString(schema, input, customNormalizers) {
  if (typeof input !== 'string') return input

  const { format } = schema
  const customStringNormalizers = customNormalizers ? customNormalizers.string : {}

  if (customStringNormalizers && Object.keys(customStringNormalizers).includes(format)) {
    return customStringNormalizers[format](input)
  }

  switch (format) {
    case 'svenskt-bankgironummer':
      return normalizeSvensktBankgironummer(input)
    case 'svenskt-plusgironummer':
      return normalizeSvensktPlusgironummer(input)
    case 'svenskt-personnummer':
    case 'svenskt-id-nummer':
      return normalizeSvensktPersonnummer(input)
    case 'svenskt-organisationsnummer':
      return normalizeSvensktOrganisationsnummer(input)
    case 'svenskt-bank-clearingnummer':
      return normalizeSvensktBankClearingnummer(input)
    case 'svenskt-bank-kontonummer':
      return normalizeSvensktBankKontonummer(input)
    case 'svenskt-postnummer':
      return normalizeSvensktPostnummer(input)
    case 'phone-number':
      return normalizePhoneNumber(input)
    case 'date':
      return normalizeDate(input)
    case 'time':
      return normalizeTime(input)
    case 'http-uri':
      return normalizeHttpUri(input)
    case 'email':
      return normalizeEmail(input)
    default:
      return input
  }
}

function normalizeSchema(schema, input, customNormalizers) {
  const typeAsArray = [].concat(schema.type)

  for (const type of typeAsArray) {
    if (type === 'array' && Array.isArray(input)) return normalizeArray(schema, input, customNormalizers)
    if (type === 'object' && isPlainObj(input)) return normalizeObject(schema, input, customNormalizers)
    if (type === 'string' && typeof input === 'string') return normalizeString(schema, input, customNormalizers)
  }

  return input
}

module.exports = function createNormalizer(schema, customNormalizers) {
  return function normalize(input) {
    return normalizeSchema(schema, input, customNormalizers)
  }
}
